import { ReactElement } from 'react';

export interface PatientCentralIframeProps {
  url: string;
  title: string;
}

export function PatientCentralIframe({ url, title }: PatientCentralIframeProps): ReactElement {
  return <iframe src={url} style={{ width: '100%', height: '100vh', border: 'none' }} title={title} />;
}
